/* eslint-disable react/destructuring-assignment */
import { cva } from "class-variance-authority";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import React from "react";
import { Avatar, Text } from "ui-components";

import { ConversationMessageEntity } from "@/src/hooks/api/generated";
import { useAuth } from "@/src/hooks/useAuth";

import { MessageAttachments } from "./MessageAttachments";

dayjs.extend(relativeTime);

export interface IMessageProps {
  message: ConversationMessageEntity;
}

export function Message({ message }: IMessageProps): JSX.Element {
  const { authData } = useAuth();

  const isOwnMessage = authData?.id === message.sender_user.id;
  return (
    <div className={messageWrapperClass({ isOwnMessage })}>
      <Avatar
        size="xxs"
        alt=""
        src={message.sender_user?.userTaxonomy?.image?.public_id}
      />
      <div className={messageClass({ isOwnMessage })}>
        <div className="flex gap-2 items-center mt-1">
          <Text variant="base-bold">
            {isOwnMessage ? "You" : message.sender_user.first_name}
          </Text>
          <Text variant="base-thin">at</Text>
          <Text variant="base-thin">
            {dayjs(message?.createdAt).format("hh:mm a [ on ] DD/MM/YY")}
          </Text>
        </div>
        {message.content && (
          <div className={contentClass({ isOwnMessage })}>
            <Text>{message.content}</Text>
          </div>
        )}
        {message.messageAttachments.map((attachment) => (
          <MessageAttachments
            attachment={attachment}
            isOwnMessage={isOwnMessage}
          />
        ))}
      </div>
    </div>
  );
}

export const messageWrapperClass = cva("flex gap-2 ", {
  variants: {
    isOwnMessage: {
      true: "flex-row-reverse",
      false: "",
    },
  },
});

export const messageClass = cva("flex flex-1 w-full flex-col gap-2 ", {
  variants: {
    isOwnMessage: {
      true: "justify-end items-end",
      false: "",
    },
  },
});
export const contentClass = cva("w-2/3 rounded-2xl p-2 ", {
  variants: {
    isOwnMessage: {
      true: "bg-brand-light-gray",
      false: "bg-brand-primary",
    },
  },
});
